import { convertToMinutes } from "@memorang/helpers/common";

export const timePerQuestion = 72;

const useProcessTimeEstimate = (numItemsSelected: number) => {
	return `~${convertToMinutes(numItemsSelected * timePerQuestion)} minutes`;
};

export default useProcessTimeEstimate;
